import { z } from "zod";
/**
 * What paid for one Agent run, shown under the finished run. Mirrors the
 * control-plane `aiRunFundingSchema`; agent-protocol cannot import contracts.
 */
export const conversationRunFundingSchema = z.object({
    source: z.enum(["own", "shared", "app", "organisation", "included"]),
    label: z.string().trim().min(1).max(200),
    costNanodollars: z.string().regex(/^(0|[1-9][0-9]{0,39})$/).nullable(),
    tokens: z.string().regex(/^(0|[1-9][0-9]{0,39})$/).nullable(),
}).strict();
//# sourceMappingURL=run-funding.js.map